import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21.9909 2.44197C21.9918 2.31992 21.9926 2.19794 21.9947 2.07617C21.8739 2.07821 21.7529 2.07909 21.6318 2.07998C21.362 2.08195 21.0918 2.08393 20.8228 2.09867C20.7433 2.10303 20.6312 2.11073 20.4882 2.12435C20.2022 2.15159 19.7924 2.20248 19.2724 2.29748C18.4243 2.45245 17.2837 2.7247 15.9099 3.20278L17.2209 9.00413L20.2908 9.6766C21.0475 7.84627 21.465 6.32036 21.6952 5.20078C21.8276 4.55735 21.898 4.04848 21.9354 3.69349C21.9541 3.51599 21.9646 3.37697 21.9705 3.27882C21.9871 3.00067 21.989 2.72115 21.9909 2.44197Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.4477 11.5393L16.1755 10.8226L8.50406 9.20504L11.4799 22.4864C15.4397 18.4438 17.9091 14.6688 19.4477 11.5393Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.52057 22.8893L6.29813 8.50729C4.66009 9.74819 2.9434 11.228 1.17893 12.9925L0.700195 13.4712L0.966891 14.0935C1.36709 15.0273 2.63859 17.2806 4.71446 19.3564C6.50453 21.1465 8.42649 22.3384 9.52057 22.8893Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.25565 7.10869L15.0666 8.54479L14.0251 3.93558C12.3215 4.66642 10.3728 5.68621 8.25565 7.10869Z"}}]};

const BambooShootFilled = Vue.extend<IconProps>({
  name: 'BambooShootFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'bamboo-shoot-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default BambooShootFilled;
